import useUserStore from '../user.store';
import { useWatchIfAuthenticated } from '~/domains/auth';

/**
 * Call callback function after user.selected.currency param is changed
 *
 * @param callback - callback function to call
 *
 */
export default function useOnChangeCurrency(callback: () => void): void {
  const userStore = useUserStore();

  useWatchIfAuthenticated(() => userStore.currency, callback);
}
